import { render } from "./Todo.vue?vue&type=template&id=3802006d&scoped=true"
import script from "./Todo.vue?vue&type=script&lang=ts"
export * from "./Todo.vue?vue&type=script&lang=ts"

import "./Todo.vue?vue&type=style&index=0&id=3802006d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3802006d"

export default script